import React, { createContext } from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "styled-components";
import { sample, reject } from "lodash";
import Footer from "./Footer/Footer";
import Warning from "./Warning/Warning";
import { colors } from "../util";

import { Bg } from "./Home/styles";

const videoOptions = [
  "MGS22_1_slow",
  "MGS22_2_slow",
  "MGS22_3_slow",
  "MGS22_4_slow",
  "MGS22_5_slow",
  "MGS22_6_slow",
  "MGS22_7_slow",
  "MGS22_8_slow",
];

const themes = {
  orange: {
    color: colors.alt.orange,
  },
  blue: {
    color: colors.alt.blue,
  },
  green: {
    color: colors.alt.green,
  },
  deepBlue: {
    color: colors.alt.deepBlue,
  },
  pink: {
    color: colors.alt.pink,
  },
};

class Page extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      theme: themes.orange,
      video: sample(videoOptions),
    };
    this.changeTheme = this.changeTheme.bind(this);
  }

  componentWillMount() {
    this.changeTheme();
  }

  changeTheme() {
    const t = reject(themes, this.state.theme);
    let s = sample(t);
    this.setState({ theme: s });
  }

  render() {
    const { children, ...props } = this.props;
    const { theme } = this.state;
    return (
      <ThemeProvider theme={theme}>
        <page {...props} onClick={this.changeTheme}>
          {/* <Warning /> */}
          {children}
          <Bg>
            <Footer />
          </Bg>
        </page>
      </ThemeProvider>
    );
  }
}

Page.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
};
Page.defaultProps = {
  id: "page",
};
export default Page;



// WEBPACK FOOTER //
// ./src/components/Page.jsx